export default {
    'common.more': 'More',
    'common.collapse': 'Collapse',
    'common.noEmpty': 'Tidak boleh kosong',
    'common.validator.mobile': 'Kesalahan format nomor telepon',
    'common.validator.email': 'Format kotak surat salah',
    'common.validator.number': 'Silakan masukkan nomor yang benar',
    'common.validator.password': 'Terdiri dari angka, huruf, dan garis bawah, dalam {length} karakter',
    'common.validator.maxLength': 'Dalam {length} karakter',
    'common.btn.search': 'Pencarian',
    'common.btn.reset': 'Setel ulang',
    'common.btn.refresh': 'Segarkan',
    'common.btn.add': 'Tambah baru',
    'common.btn.edit': 'penyusunan',
    'common.btn.delete': 'Hapus',
    'common.btn.confirm': 'Pasti',
    'common.btn.cancel': 'Batal',
    'common.btn.update': 'Ubah',
    'common.btn.yes': 'Ya',
    'common.btn.no': 'Tidak',
    'common.btn.look': 'Lihat',
    'common.btn.operate': 'Operasi',
    'common.datePicker.startDate': 'Waktu mulai',
    'common.datePicker.endDate': 'Waktu selesai',
    'common.input.placeholder': 'Silakan masuk',
    'common.default.option': 'Silakan pilih',
    'common.tip': 'Prompt',
    'common.edit.message': 'Apakah Anda yakin untuk memodifikasi?',
    'common.success': 'Sukses',
    'widget.alert.yes': 'Pasti',
    'widget.alert.no': 'Batal',
    'nav.language': 'Pengaturan bahasa',
    'nav.language.select': 'Silakan masukkan bahasa yang Anda gunakan',
    'nav.bread.home': 'Rumah',
    'language.zh': '简体中文',
    'language.mx': 'Mexican',
    'language.en': 'English',
    'language.vi': 'Tiếng việt nam',
    'language.id': 'Indonesian',
    'nav.version': 'Informasi versi',
    'version.version': 'Nomor versi',
    'version.pushUser': 'Produser',
    'version.developer': 'Pengembang',
    'version.releaseTime': 'Waktu rilis',
    'version.content': 'Konten versi',
    'nav.login': 'Masuk',
    'nav.logout': 'Pintu keluar yang aman',
    'nav.logout.tips': 'Người dùng hiện tại sẽ được đăng xuất và trở lại cổng thông tin hệ thống.',
    'nav.logout.confirm': 'Xác nhận đăng xuất người dùng hiện tại?',
    'nav.password': 'Ubah kata sandi',
    'nav.session.add': 'Tambah akun',
    'nav.password.old': 'Kata sandi lama',
    'nav.password.new': 'Kata sandi baru',
    'nav.password.newPasswordConfirm': 'Konfirmasikan kata sandi baru',
    'nav.password.newPasswordConfirm.error': 'Kata sandi input tidak konsisten dua kali',
    'nav.historyback': 'Kembali',
    'nav.brand.text': 'Pengelolaan dana',
    'nav.account.title': 'Manajemen akun',
    'nav.account.item.delete': 'Anda yakin ingin menghapus akun ini?',
    'nav.account.item.confirm.state': 'Anda yakin ingin {state} akun?',
    'nav.account.company.subTitle': 'Akun perusahaan',
    'nav.account.company.searchForm.state': 'Status',
    'nav.account.company.searchForm.stateValue.enable': 'Aktifkan',
    'nav.account.company.searchForm.stateValue.disable': 'Nonaktifkan',
    'nav.account.company.tableColumn.accountId': 'ID akun',
    'nav.account.company.tableColumn.accountName': 'Nama',
    'nav.account.company.tableColumn.currency': 'Mata uang',
    'nav.account.company.tableColumn.balance': 'Saldo akun',
    'nav.account.company.tableColumn.cardNumber': 'Nomor rekening',
    'nav.account.company.tableColumn.bankName': 'Bank',
    'nav.account.company.tableColumn.phone': 'Input No. HP',
    'nav.account.company.tableColumn.email': 'Email',
    'nav.account.company.tableColumn.createTime': 'Waktu pembukaan akun',
    'nav.account.company.tableColumn.updateTime': 'Perbarui waktu',
    'nav.account.company.tableColumn.state': 'Status',
    'nav.account.company.tableColumn.operation': 'Operasi',
    'nav.account.company.columnBtn.recharge': 'Isi ulang',
    'nav.account.company.formData.addTitle': 'Tambahkan akun perusahaan',
    'nav.account.company.formData.editTitle': 'Edit akun perusahaan',
    'nav.account.company.formData.accountName': 'Nama akun',
    'nav.account.company.formData.currency': 'Mata uang',
    'nav.account.company.formData.balance': 'Total',
    'nav.account.company.formData.cardNumber': 'Nomor rekening',
    'nav.account.company.formData.bankName': 'Bank',
    'nav.account.company.formData.phone': 'Input No. HP',
    'nav.account.company.formData.email': 'Email',
    'nav.account.company.formData.state': 'Status',
    'nav.account.company.formData.error.accountName.required': 'Nama akun tidak boleh kosong',
    'nav.account.company.formData.error.currency.required': 'Mata uang tidak boleh kosong',
    'nav.account.company.formData.recharge.title': 'Isi ulang',
    'nav.account.company.formData.recharge.balance': 'Saldo akun',
    'nav.account.company.formData.recharge.amount': 'Jumlah isi ulang',
    'nav.account.company.formData.recharge.amount.required': 'Jumlah isi ulang tidak boleh kosong',
    'nav.account.personal.subTitle': 'Sisi aset',
    'nav.account.blacklist.subTitle': 'Manajemen daftar hitam',
    'nav.account.blacklist.pushItem.title': 'Daftar hitam informasi berikut',
    'nav.account.blacklist.TriggerConditions.title': 'Điều kiện kích hoạt',
    'nav.account.blacklist.TriggerConditions.overdueDays.title': 'Hari lewat jatuh tempo >= ',
    'nav.subjectMatter.title': 'Manajemen item lelang',
    'nav.subjectMatter.credit': 'Manajemen pinjaman',
    'nav.subjectMatter.credit.receipt': 'Dokumen pinjaman',
    'nav.subjectMatter.credit.check': 'Audit pemberian pinjaman',
    'nav.subjectMatter.loan': 'Proyek pinjaman',
    'nav.subjectMatter.loan.detail': 'Rincian pembayaran',
    'nav.subjectMatter.repayment': 'Manajemen pembayaran',
    'nav.subjectMatter.repayment.unpaid': 'Rincian pembayaran',
    'nav.subjectMatter.repayment.repaid': 'Telah membayarkan pinjaman',
    'nav.subjectMatter.repayment.detail': 'Rincian pembayaran',
    'nav.subjectMatter.repayment.result': 'Hasil pembayaran',
    'nav.subjectMatter.repayment.penalty': 'Catatan bunga denda',
    'nav.subjectMatter.cashDetail': 'Rincian dana',
    'nav.subjectMatter.cashDetail.table.clumn.customerId': 'Identifikasi pelanggan',
    'nav.subjectMatter.cashDetail.table.clumn.cameraId': 'Identifikasi entri',
    'nav.subjectMatter.cashDetail.table.clumn.amount': 'Jumlah perubahan',
    'nav.subjectMatter.cashDetail.table.clumn.currency': 'Mata uang',
    'nav.subjectMatter.cashDetail.table.clumn.payNo': 'Nomor seri',
    'nav.subjectMatter.cashDetail.table.clumn.fundAction': 'Tindakan modal',
    'nav.subjectMatter.cashDetail.table.clumn.fundType': 'Jenis dana',
    'nav.subjectMatter.cashDetail.table.clumn.debit': 'Tambah-kurangi',
    'nav.subjectMatter.cashDetail.table.clumn.remark': 'Catatan',
    'nav.subjectMatter.cashDetail.table.clumn.createTime': 'Waktu pembuatan',
    'nav.subjectMatter.cashDetail.table.clumn.updateTime': 'Perbarui waktu',
    'cash.searchForm.cameraId': 'Nomor pesanan',
    'cash.searchForm.accountId': 'ID akun',
    'cash.searchForm.fundType': 'Jenis dana',
    'cash.searchForm.debit': 'Jenis perubahan',
    'cash.tableData.payNo': 'Nomor seri',
    'cash.tableData.lid': 'Nomor tagihan',
    'cash.tableData.cameraId': 'Nomor pesanan',
    'cash.tableData.id': 'ID akun',
    'cash.tableData.debit': 'Jenis perubahan',
    'cash.tableData.debit.add': 'Plus',
    'cash.tableData.debit.reduce': 'Minus',
    'cash.tableData.currency': 'Mata uang',
    'cash.tableData.amount': 'Jumlah perubahan',
    'cash.tableData.fundType': 'Jenis dana',
    'cash.tableData.fundType.tenant': 'Penyewa',
    'cash.tableData.fundType.personal': 'Individu',
    'cash.tableData.fundType.cash': 'Pengajuan aku',
    'cash.tableData.remark': 'Deskripsi',
    'cash.tableData.remark.income': 'Penghasilan:',
    'cash.tableData.remark.expenditure': 'Pengeluaran:',
    'cash.tableData.createTime': 'Waktu pembuatan',
    'repayment.unpaid.searchForm.cameraId': 'Nomor pesanan',
    'repayment.unpaid.searchForm.shouldTimeDateValue': 'Waktu pembayaran hutang ',
    'repayment.unpaid.searchForm.finishTimeDateValue': 'Waktu pelunasan',
    'repayment.unpaid.searchForm.payState': 'Status',
    'repayment.unpaid.searchForm.doubleLoan': 'Pelanggan pinjaman atau tidak',
    'repayment.unpaid.operation': 'Operasi pinjaman',
    'repayment.unpaid.operation.manual': 'Operasi penghapusan manual',
    'repayment.unpaid.operation.partial': 'Pembayaran sebagian',
    'repayment.unpaid.operation.substract': 'Pengurangan pembayaran',
    'repayment.unpaid.operation.settlement': 'Penyelesaian normal',
    'repayment.unpaid.operation.extends': 'mendapat',
    'repayment.unpaid.view': 'Lihat',
    'repayment.unpaid.view.detail': 'Rincian pembayaran',
    'repayment.unpaid.view.result': 'Hasil pembayaran',
    'repayment.unpaid.tableData.cameraId': 'Nomor pesanan',
    'repayment.unpaid.tableData.productName': 'Nama produk',
    'repayment.unpaid.tableData.pauseStatus': 'Tangguhkan penagihan',
    'repayment.unpaid.tableData.noPauseStatus': 'Penagihan tidak ditangguhkan',
    'repayment.unpaid.tableData.pauseRemark': 'Catatan',
    'repayment.unpaid.tableData.dialog.title.pasuse': 'Tangguhkan penagihan tagihan',
    'repayment.unpaid.tableData.dialog.title.resume': 'Lanjutkan penagihan tagihan',
    'repayment.unpaid.tableData.dialog.hint.pause': 'Masukkan catatan penangguhan',
    'repayment.unpaid.tableData.dialog.hint.resume': 'Masukkan catatan pelanjutan',
    'repayment.unpaid.tableData.dialog.btn.cancel': 'Batal',
    'repayment.unpaid.tableData.dialog.btn.pause': 'Tangguhkan',
    'repayment.unpaid.tableData.dialog.btn.resume': 'Lanjutkan',
    'repayment.unpaid.tableData.customerName': 'Nama',
    'repayment.unpaid.tableData.indexs': 'Periode',
    'repayment.unpaid.tableData.shouldCapital': 'Hutang uang pokok pinjaman',
    'repayment.unpaid.tableData.factCapital': 'Pembayaran uang pokok pinjaman aktual',
    'repayment.unpaid.tableData.shouldInterest': 'Hutang bunga',
    'repayment.unpaid.tableData.factInterest': 'Pembayaran bunga aktual',
    'repayment.unpaid.tableData.shouldFine': 'Hutang bunga denda',
    'repayment.unpaid.tableData.factFine': 'Pembayaran bunga denda aktual',
    'repayment.unpaid.tableData.shouldOtherTotalFee': 'Hutang biaya layanan',
    'repayment.unpaid.tableData.factOtherTotalFee': 'Pembayaran biaya layanan aktual',
    'repayment.unpaid.tableData.shouldOverdueFee': 'Hutang ganti rugi',
    'repayment.unpaid.tableData.factOverdueFee': 'Pembayaran ganti rugi aktual',
    'repayment.unpaid.tableData.subtractAmount': 'Pengurangan jumlah',
    'repayment.unpaid.tableData.shouldTime': 'Waktu pembayaran hutang',
    'repayment.unpaid.tableData.finishTime': 'Waktu pelunasan',
    'repayment.unpaid.tableData.isExtends': 'Untuk memperluas',
    'repayment.unpaid.tableData.doubleLoan': 'Pelanggan pinjaman atau tidak',
    'repayment.unpaid.specialviet.form.title': 'Pelunasan',
    'repayment.unpaid.specialviet.form.totalAmount': 'Total jatuh tempo',
    'repayment.unpaid.specialviet.form.paidAmount': 'Jumlah pembayaran ini',
    'repayment.unpaid.specialviet.form.capitalAmount': 'Pelunasan pokok',
    'repayment.unpaid.specialviet.form.interestAmount': 'Bunga atas pembayaran ini',
    'repayment.unpaid.specialviet.form.penaltyAmount': 'Bunga penalti untuk pembayaran ini',
    'repayment.unpaid.specialviet.form.unpaidAmount': 'Jumlah yang tersisa',
    'repayment.unpaid.specialviet.form.factTime.required': 'Waktu pembayaran yang sebenarnya tidak boleh kosong',
    'repayment.unpaid.specialviet.form.timestatus.label': 'Waktu kedatangan＞Waktu pembayaran aktual pelanggan, Diperlukan penalti ekstra',
    'repayment.unpaid.manualDialog.title': 'Operasi penghapusan manual',
    'repayment.unpaid.manualDialog.partPaymentData.unpaidAmount': 'Jumlah total yang belum dibayar',
    'repayment.unpaid.manualDialog.partPaymentData.capitalAmount': 'Uang pokok yang belum dibayar',
    'repayment.unpaid.manualDialog.partPaymentData.interestAmount': 'Jumlah hutang bunga tersisa',
    'repayment.unpaid.manualDialog.partPaymentData.paidAmount': 'Jumlah pembayaran ini',
    'repayment.unpaid.manualDialog.partPaymentData.writeOffAmount': 'Jumlah penghapusan ini',
    'repayment.unpaid.manualDialog.manualRules.paidAmount.required': 'Jumlah pembayaran tidak boleh kosong',
    'repayment.unpaid.manualDialog.onManualPaidSubmit.success': 'Berhasil dihapuskan',
    'repayment.unpaid.manualDialog.onPartialPaidSubmit.success': 'Pelunasan yang berhasil',
    'repayment.unpaid.extendsDialog.onExtendsPaidSubmit.success': 'Mendapat sukses',
    'repayment.unpaid.partialDialog.title': 'Halaman operasi untuk pembayaran bagian',
    'repayment.unpaid.partialDialog.htitle1': 'Jumlah yang belum dibayar saat ini',
    'repayment.unpaid.partialDialog.htitle2': 'Perhitungan percobaan pembayaran',
    'repayment.unpaid.partialDialog.htitle3': 'Waktu pembayaran aktual',
    'repayment.unpaid.partialDialog.unpaidData.paidAmount': 'Pembayaran total',
    'repayment.unpaid.partialDialog.unpaidData.unpaidAmount': 'Jumlah total yang belum dibayar',
    'repayment.unpaid.partialDialog.unpaidData.capitalAmount': 'Uang pokok yang belum dibaya',
    'repayment.unpaid.partialDialog.unpaidData.interestAmount': 'Bunga yang belum dibayar',
    'repayment.unpaid.partialDialog.unpaidData.penaltyAmount': 'Bunga denda yang belum dibayar',
    'repayment.unpaid.partialDialog.unpaidData.feesAmount': 'Biaya layanan yang belum dibayar',
    'repayment.unpaid.partialDialog.calculateData.inputAmount': 'Jumlah pembayaran ini',
    'repayment.unpaid.partialDialog.calculateData.trialCalculation': 'Perhitungan percobaan pembayaran',
    'repayment.unpaid.partialDialog.calculateData.unpaidAmount': 'Total jumlah percobaan pembayaran',
    'repayment.unpaid.partialDialog.calculateData.capitalAmount': 'Percobaan pembayaran uang pokok',
    'repayment.unpaid.partialDialog.calculateData.interestAmount': 'Percobaan pembayaran bunga',
    'repayment.unpaid.partialDialog.calculateData.penaltyAmount': 'Percobaan pembayaran bunga denda',
    'repayment.unpaid.partialDialog.calculateData.feesAmount': 'Percobaan pembayaran biaya layanan',
    'repayment.unpaid.partialDialog.calcPartRepaymentHandler.notNumber': 'Silakan masukkan nomor yang benar',
    'repayment.unpaid.partialDialog.calcPartRepaymentHandler.validNumber': 'Silakan masukkan nomor yang benar',
    'repayment.unpaid.partialDialog.onPartailPaidSubmit.confirm': 'Jumlah pembayaran adalah {inputAmount}. Apakah Anda ingin melanjutkan?',
    'repayment.unpaid.substractDialog.title': 'Operasi pengurangan pembayaran',
    'repayment.unpaid.substractDialog.htitle2': 'Uji coba pengurangan pembayaran',
    'repayment.unpaid.substractDialog.calculateData.inputAmount': 'Jumlah pengurangan ini',
    'repayment.unpaid.substractDialog.calculateData.unpaidAmount': 'Pengurangan pembayaran',
    'repayment.unpaid.substractDialog.calculateData.capitalAmount': 'Pelunasan pokok',
    'repayment.unpaid.substractDialog.calculateData.interestAmount': 'Pembayaran bunga',
    'repayment.unpaid.substractDialog.calculateData.penaltyAmount': 'Denda pelunasan',
    'repayment.unpaid.substractDialog.calculateData.feesAmount': 'Biaya manajemen pengurangan pembayaran',
    'repayment.unpaid.substractDialog.onPartailPaidSubmit.confirm':
        'Jumlah pengurangan ini adalah {inputAmount}. Apakah Anda ingin melanjutkan?',
    'repayment.unpaid.settlementDialog.title': 'Operasi kliring normal',
    'repayment.unpaid.extendsDialog.title': 'mendapat',
    'repayment.unpaid.extendsDialog.htitle1': 'Jumlah telah dikonfirmasi',
    'repayment.unpaid.extendsDialog.unpaidData.extendsAmount': 'Mendapat pembayaran',
    'repayment.unpaid.extendsDialog.unpaidData.extendsFee': 'Biaya pemeliharaan yang belum dibayarkan',
    'repayment.unpaidDetail.title.repaidDetail': 'Rincian untuk yang belum dibayar',
    'repayment.unpaidDetail.title.repaidRecord': 'Catatan pembayaran',
    'repayment.unpaidDetail.title.substractRecord': 'Catatan pengurangan pembayaran',
    'repayment.unpaidDetail.detailList.totalAmount': 'Sub total hutang',
    'repayment.unpaidDetail.detailList.couponAmount': 'Jumlah pengurangan kupon',
    'repayment.unpaidDetail.detailList.paidAmount': 'Jumlah telah dibayar',
    'repayment.unpaidDetail.detailList.unpaidAmount': 'Jumlah total hutang tersisa',
    'repayment.unpaidDetail.detailList.capitalAmount': 'Uang pokok tersisa',
    'repayment.unpaidDetail.detailList.interestAmount': 'Bunga tersisa',
    'repayment.unpaidDetail.detailList.penaltyAmount': 'Bunga yang tersisa',
    'repayment.unpaidDetail.detailList.feesAmount': 'Biaya lain-lain',
    'repayment.unpaidDetail.recordList.id': 'Nomor pembayaran',
    'repayment.unpaidDetail.recordList.factTime': 'Waktu dibayar',
    'repayment.unpaidDetail.recordList.factAmount': 'Jumlah yang dibayarkan',
    'repayment.unpaidDetail.recordList.factCapital': 'Penerimaan kapital aktual',
    'repayment.unpaidDetail.recordList.factInterest': 'Penerimaan bunga aktual',
    'repayment.unpaidDetail.recordList.factFine': 'Penerimaan bunga denda aktual',
    'repayment.unpaidDetail.recordList.factFeeAmount': 'Biaya lain-lain',
    'repayment.unpaidDetail.recordList.remark': 'Komentar',
    'repayment.unpaidDetail.recordList.updateRemark': 'Ubah catatan',
    'repayment.unpaidDetail.recordList.updateRemark.success': 'Sukses',
    'repayment.unpaidDetail.substractList.operator': 'Operator',
    'repayment.unpaidDetail.substractList.factTime': 'Waktu pembayaran',
    'repayment.unpaidDetail.substractList.factAmount': 'Pengurangan pembayaran',
    'repayment.unpaidDetail.substractList.factCapital': 'Pelunasan pokok',
    'repayment.unpaidDetail.substractList.factInterest': 'Pembayaran bunga',
    'repayment.unpaidDetail.substractList.factFine': 'Denda pelunasan',
    'repayment.unpaidDetail.substractList.factFeeAmount': 'Pelunasan biaya lainnya',
    'repayment.unpaidDetail.substractList.remark': 'Komentar',
    'repayment.unpaidDetail.lastIndex': 'Masalah sebelumnya',
    'repayment.unpaidDetail.nextIndex': 'Masalah berikutnya',
    'repayment.penalty.searchForm.cameraId': 'Nomor pesanan',
    'repayment.penalty.searchForm.shouldTimeDateValue': 'Waktu pembayaran hutang ',
    'repayment.penalty.tableData.cameraId': 'Nomor pesanan',
    'repayment.penalty.tableData.productName': 'Nama produk',
    'repayment.penalty.tableData.customerName': 'Nama',
    'repayment.penalty.tableData.indexs': 'Periode',
    'repayment.penalty.tableData.shouldFine': 'Bunga denda kumulatif',
    'repayment.penalty.tableData.factFine': 'Pembayaran bunga denda aktual',
    'repayment.penalty.tableData.state': 'Status',
    'repayment.penalty.tableData.shouldTime': 'Waktu pembayaran hutang',
    'repayment.penalty.view': 'Lihat',
    'repayment.penalty.operation': 'Operasi',
    'repayment.doubleLoan.first': 'Tidak',
    'repayment.doubleLoan.double': 'adalah',
    'loan.searchForm.cameraId': 'Nomor pesanan',
    'loan.searchForm.cardNo': 'Nomor sertifikat',
    'loan.searchForm.state': 'Status',
    'loan.searchForm.releaseTime': 'Waktu pemberian pinjaman',
    'loan.searchForm.customerName': 'Nama',
    'loan.searchForm.phone': 'Input No. HP',
    'loan.tableData.cameraId': 'Nomor pesanan',
    'loan.tableData.productName': 'Nama produk',
    'loan.tableData.customerName': 'Nama',
    'loan.tableData.contractAmount': 'Harga kontrak',
    'loan.tableData.amount': 'Jumlah pinjaman yang harus diberikan',
    'loan.tableData.interest': 'Total bunga',
    'loan.tableData.feeAmount': 'Hutang biaya layanan',
    'loan.tableData.loanCycle': 'Batas waktu',
    'loan.tableData.rate': 'Suku bunga',
    'loan.tableData.state': 'Status',
    'loan.tableData.createTime': 'Waktu lulus peninjauan kredit',
    'loan.tableData.reviewTime': 'Tinjau waktu',
    'loan.tableData.releaseTime': 'Waktu pemberian pinjaman',
    'loan.tableData.operation': 'Operasi',
    'loan.tableData.cancelLoan': 'Tinggalkan pelelangan',
    'loan.tableData.view': 'Lihat paket pembayaran',
    'loan.tableData.viewRepayment': 'Lihat detail pembayaran',
    'loan.tableData.loanState.init': 'Tunggu diaudit',
    'loan.tableData.loanState.lending': 'Sudah memberikan pinjaman',
    'loan.tableData.loanState.finish': 'Telah lunas',
    'loan.tableData.loanState.writeoff': 'Menghapuskan sesudah verifikasi',
    'loan.tableData.loanState.cancel': 'Batal',
    'loan.tableData.loanState.fail': 'Kegagalan peminjaman',
    'loan.tableData.loanState.refuse': 'Ditolak',
    'loan.tableData.loanState.transaction': 'Pinjaman',
    'loan.tableData.rateType.day': 'Nafas{rate}%',
    'loan.tableData.rateType.month': 'Bunga bulanan{rate}%',
    'loan.tableData.rateType.year': 'Bunga tahunan{rate}%',
    'loan.tableData.loanCycleUnit.day': '{loanCycle}Hari',
    'loan.tableData.loanCycleUnit.month': '{loanCycle}Bulan',
    'loan.confirm.cancelLoan': 'Tentukan tinggalkan pelelangan?',
    'loan.cancelLoan.success': 'Tinggalkan pelelangan berhasil',
    'loandetail.tableData.id': 'ID',
    'loandetail.tableData.productName': 'Nama produk',
    'loandetail.tableData.customerName': 'Nama',
    'loandetail.tableData.indexs': 'Periode',
    'loandetail.tableData.shouldCapital': 'Hutang uang pokok pinjaman',
    'loandetail.tableData.factCapital': 'Pembayaran uang pokok pinjaman aktual',
    'loandetail.tableData.shouldInterest': 'Hutang bunga',
    'loandetail.tableData.factInterest': 'Pembayaran bunga aktual',
    'loandetail.tableData.shouldFine': 'Hutang bunga denda',
    'loandetail.tableData.factFine': 'Pembayaran bunga denda aktual',
    'loandetail.tableData.shouldOtherTotalFee': 'Hutang biaya layanan',
    'loandetail.tableData.factOtherTotalFee': 'Pembayaran biaya layanan aktual',
    'loandetail.tableData.shouldOverdueFee': 'Hutang ganti rugi',
    'loandetail.tableData.factOverdueFee': 'Pembayaran ganti rugi aktual',
    'loandetail.tableData.shouldTime': 'Waktu pembayaran hutang',
    'loandetail.tableData.factTime': 'Waktu dibayar',
    'loandetail.tableData.view': 'Lihat',
    'credit.check.tableData.bankName': 'Kartu bank',
    'credit.check.tableData.bankCard': 'Nomor rekening',
    'credit.check.tableData.phone': 'Input No. HP',
    'credit.check.tableData.cardNo': 'Nomor sertifikat',
    'credit.check.aciton.view': 'Lihat',
    'credit.check.aciton.check': 'Audit pemberian pinjaman',
    'credit.check.button.reject': 'Tolak',
    'credit.check.button.approve': 'Lulus audit',
    'credit.check.button.batchReview': 'Ulasan batch',
    'credit.check.dialog.remark': 'Catatan',
    'credit.check.dialog.rejected': 'Ditolak setelah audit',
    'credit.check.dialog.approved': 'Lulus audit',
    'repayment.state.repaid': 'Telah membayarkan pinjaman',
    'repayment.state.unpaid': 'Tidak dibayar',
    'repayment.state.normal': 'Pembayaran normal',
    'repayment.state.overdue': 'Keterlambatan',
    'repayment.state.afterOverdue': 'Pembayaran jatuh tempo',
    'repayment.state.partial': 'Pembayaran sebagian',
    'repayment.state.afterPartial': 'Pembayaran sebagian',
    'repayment.state.manual': 'Penghapusan manual',
    'repayment.state.cancel': 'Batal',
    'repayment.isExtends.notExtends': 'Belum meluas',
    'repayment.isExtends.extending': 'Dalam ekspansi',
    'repayment.isExtends.extends': 'Telah berkembang',
    // 催收核销
    'repayment.hx.status': 'status',
    'repayment.hx.overrideType': 'tipe override',
    'repayment.hx.orderNumber': 'jumlah order',
    'repayment.hx.repaymentAmount': 'Jumlah Pembayaran Kembali',
    'repayment.hx.createTime': 'Waktu penciptaan',
    'repayment.hx.updateTime': 'Perbarui waktu',
    'repayment.hx.createUserName': 'Pencipta',
    'repayment.hx.updateUserName': 'pembaru',
    'repayment.hx.viewCredentials': 'Lihat kredensial',
    'repayment.hx.operating': 'Pengoperasian',
    'repayment.hx.manualOverride': 'Timpa manual',
    'repayment.hx.partialRepayment': 'Pembayaran sebagian',
    'repayment.hx.normalSettlement': 'Permukiman normal',
    'repayment.hx.cancel': 'membatalkan',
    'repayment.tallyBillState.waitApprove': 'Menunggu keputusan',
    'repayment.tallyBillState.finishApprove': 'Penghapusan selesai',
    'repayment.tallyBillState.cancelApprove': 'Dibatalkan',
    'repayment.tallyBillType.inbursaRepay': 'Pembayaran kembali dengan INBURSA',
    'repayment.tallyBillType.overdueRepay': 'Pembayaran kembali oleh pengguna setelah penundaan jangka panjang',
    'repayment.hx.noVoucherUpload': 'Tidak ada voucher yang diupload untuk dokumen saat ini',
    'repayment.hx.stateNotSupportOperation': 'Keadaan saat ini tidak mendukung operasi',
    'repayment.hx.cancelSuccess': 'Batalkan kesuksesan',
    'repayment.hx.sureCancel': 'Apakah Anda yakin untuk membatalkan',
    'repayment.hx.cancelFailed': 'Pembatalan gagal, harap periksa',
    'nav.subjectMatter.repayment.hx': 'Manajemen verifikasi koleksi',
    /** 支付管理 */
    'common.isDelete': '是否删除?',
    'status.NameNoNull': '状态不能为空',
    'sync.member': '同步会员信息',
    'typeList.filter.time': '创建时间',
    'outcome.amount': '金额',
    'callRecord.filter.serialId': '流水号',
    'serviceFee.userId': '用户ID',
    'merchant.scenario': '场景',
    'icon.copy': '复制',
    'notice.StatusNoNull': '通知状态不能为空', // noticeStatusNoNull
    'payType.name': '支付类型', // payType
    'payType.NoNull': '支付类型不能为空', // payTypeNoNull
    'merchant.StatusNoNull': '租户不能为空', // merchantStatusNoNull
    'pri.NoNull': '排序不能为空', // priNoNull
    'batch.add': '批量添加',
    'bank.id': '银行ID',
    'bank.name': '银行名称',
    'bank.icon': '图标',
    'bank.tel': '联系电话',
    'bank.website': '官网网址',
    'bank.promptMsg': '提示文案',
    'bank.payType': '支付方式',
    'bank.status': '状态', // status
    'bank.disable': '停用',
    'bank.enable': '启用',
    'bank.addDialogTitle': '添加银行',
    'bank.invalid': '无效', // invalid
    'bank.effective': '有效', // effective
    'bank.isBatchEnable': '是否启用?',
    'bank.isBatchDisable': '是否停用?',
    'bank.title': '银行', // bank
    'bank.config': '租户银行配置', // bankConfig
    'bank.tenant': '租户', // tenant
    'bank.merchantNoNull': '租户不能为空',
    'bank.NoNull': '银行不能为空',
    'bank.thridName': '三方名称',
    'bank.thridBankNameNoNull': '三方名称不能为空', // thridBankNameNoNull
    'bankCardManage.userId': '用户id',
    'bankCardManage.userName': '姓名',
    'bankCardManage.realName': '全名',
    'bankCardManage.firstName': '名',
    'bankCardManage.lastName': '姓',
    'bankCardManage.expirationYear': '有效期年',
    'bankCardManage.expirationMonth': '有效期月',
    'bankCardManage.cvv2': '信用卡安全码',
    'bankCardManage.tel': '手机号',
    'bankCardManage.IDCard': '证件号码',
    'bankCardManage.idType': '证件类型',
    'bankCardManage.cardNum': '卡号',
    'bankCardManage.oprType': '放款类型',
    'bankCardManage.cardType': '卡类型',
    'bankCardManage.email': '邮箱',
    'bankCardManage.bankName': '银行名称',
    'bankCardManage.bankId': '银行Id',
    'bankCardManage.status': '状态',
    'bankCardManage.createTime': '创建时间',
    'bankCardManage.merchantId': '租户Id',
    'bankCardManage.addDialogTitle': '添加用户银行卡管理',
    'bankCardManage.normal': '正常',
    'bankCardManage.enable': '启用',
    'bankCardManage.notenable': '未启用',
    'bankCardManage.disable': '冻结',
    'bankCardManage.identityType': '身份证',
    'bankCardManage.debitCard': '借记卡',
    'bankCardManage.creditCard': '信用卡',
    'bankCardManage.semiCreditCard': '准贷记卡',
    'bankCardManage.prepaidCard': '预付费卡',
    'bankCardManage.valid': '是否验证',
    'bankCardManage.notCheck': '未验证',
    'bankCardManage.passedCheck': '验证通过',
    'bankCardManage.failededCheck': '验证失败',
    'bankCardManage.checking': '验证中',
    'bankCardManage.cardNumNoNull': '卡号不能为空',
    'bankCardManage.identityNoNull': '证件号码不能为空',
    'bankCardManage.merchantIdNoNull': '租户Id不能为空',
    'bankCardManage.bankIdNoNull': '银行Id不能为空',
    'bankCardManage.isBatchDisable': '是否冻结?',
    'bankCardManage.ifscCode': 'IFSCCode',
    'returnCode.channelNoNull': '请选择渠道',
    'returnCode.paymentTypeNoNull': '请选择支付类型',
    'returnCode.name': '返回码', // returnCode
    'returnCode.returnMsg': '返回信息',
    'sales.failCount': '放款失败次数',
    'sales.note': '备注',
    'sales.documentsState': '单据状态',
    'sales.updateTime': '更新时间',
    'sales.documentsNo': '收款单据号',
    'sales.realName': '真实姓名',
    'sales.bankCardNo': '银行卡号',
    'repay.add': '新增',
    'repay.reviewed': '已审核',
    'repay.doing': '处理中',
    'repay.completed': '已完成',
    'repay.refused': '已拒绝',
    'repay.paying': '付款中',
    'repay.pending': '待处理',
    'repay.paymentSuccess': '付款成功',
    'repay.paymentFail': '付款失败',
    'repay.abnormal': '异常',
    'statusType.submitted': '提交',
    'statusType.pending': '待定',
    'statusType.processing': '处理中',
    'statusType.completed': '完成',
    'statusType.error': '错误',
    'bank.bankNameNoNull': '银行名称不能为空',
    'bank.realNameCannot be empty': '全名不能为空',
    'bank.phoneNoNull': '联系电话不能为空',
    'lending.FinancialCodeExpired': '财务码过期',
    'lending.HasBeenCancelled': '已取消',
    'chargeback.add': '新增',
    'chargeback.deducting': '扣款中',
    'chargeback.completeOfPart': '部分完成',
    'chargeback.closed': '已关闭',
    'chargeback.allCpmplete': '全部完成',
    'chargeback.expireDate': '已过期',
    'chargeback.exception': '异常',
    'deduct.DocumentStatus': '单据状态',
    'deduct.RepaymentCode': '还款码',
    'deduct.RepaymentPeriodTime': '还款期次',
    'deduct.ShouldAlsoAmount': '应还总额',
    'deduct.RepayAmount': '还款金额',
    'deduct.ActualAmount': '实还金额',
    'deduct.expireDate': '过期时间',
    'deduct.realAmount': '实际金额',
    'deduct.purchaseCurrency': '用户还款币种',
    'Generate return code': '生成还款码',
    'Repayment code': '还款码方式',
    'Repayment trial': '还款试算',
    'Try to pay back the principal': '试还本金',
    'Try to pay interest': '试还利息',
    'Try to pay a penalty': '试还罚息',
    'Trial management fee': '试还管理费',
    'Trial total': '试还总额',
    'Repayment channel': '还款渠道',
    'repayment.merge.generate': 'Buat kode pembayaran ({count})',
    'repayment.merge.selectedPlans': 'Rencana pembayaran terpilih',
    'repayment.merge.shouldTime': 'Tanggal jatuh tempo',
    'repayment.merge.unpaidAmount': 'Jumlah terutang',
    'repayment.merge.overdueFee': 'Denda keterlambatan',
    'repayment.merge.openLink': 'Buka tautan pembayaran',
    'repayment.merge.previewFailed': 'Perhitungan pembayaran gabungan gagal',
    'repayment.merge.invalidState': 'Hanya tagihan belum dibayar, lewat jatuh tempo, atau dibayar sebagian yang dapat dipilih',
    'repayment.merge.sameMainBillRequired': 'Hanya rencana pembayaran dari tagihan utama yang sama yang dapat digabungkan',
    'channel.loanDocuments': '放款单据',
    'channel.orderNo': '订单号',
    'channel.outcomeId': '放款单据号',
    'channel.oanApplicationDate': '放款申请日期',
    'channel.loanAmount': '放款金额',
    'channel.loanTime': '实际放款时间',
    'channel.pleaseEnterTheLoanTime': '请选择放款时间',
    'channel.lendingDate': '实际放款日期',
    'channel.lendingApplyDate': '放款申请日期',
    'channel.name': '姓名',
    'channel.idNo': '证件号',
    'channel.bvn': 'BVN',
    'channel.payStatus': '支付状态',
    'channel.confirmTheLoan': '确认放款',
    'channel.lendingAgain': '重新放款',
    'channel.cancelLending': '取消放款',
    'channel.Invalid': '失效',
    'channel.isConfirmTheLoan': '是否确认放款?',
    'channel.isConfirmTheLoanFailure': '是否确认放款失败?',
    'channel.isLoanSuccess': '是否确认放款成功?',
    'channel.isConfirmLendingAgain': '是否确认重新放款?',
    'channel.isConfirmCancelLending': '是否确认取消放款?',
    'channel.loanSuccess': '放款成功',
    'channel.loanSuccessBatch': '批量放款成功',
    'channel.manualLending': '手动放款',
    'channel.systemLending': '系统放款',
    'channel.loanFailure': '放款失败',
    'channel.loanExport': '导出',
    'channel.notPaying': '未付款',
    'channel.changeOprType': '变更放款类型',
    'channel.isConfirmChangeOprType': '是否确认变更放款类型?',
    'channel.businessParam': '是否复贷客户',
    'channel.firstLoan': '否',
    'channel.doubleLoan': '是',
    'channel.channel': '渠道',
    'channel.bankCoding': '银行编码',
    'channel.NoNull': '渠道不能为空', // channelNoNull
    'channel.threePartiesMerchantNumber': '三方商户号',
    'channel.merchantNoNull': '三方商户号不能为空',
    'channel.channelName': '渠道名称',
    'channel.channelID': '渠道ID',
    'channel.channelNumber': '渠道编号',
    'channel.createTime': '创建时间',
    'channel.theTemporaryClosureOfOpenTime': '临时关闭开启时间',
    'channel.theTemporaryClosureOfTheEndOfTime': '临时关闭结束时间',
    'channel.rule.channelID': '由数字、字母和下划线组成，20个字符以内',
    'channel.rule.channelName': '规则名称20个字符以内',
    'channel.rule.channelNumber': '100个字符以内',
    'routing.sorting': '排序', // sorting
    'routing.weight': '权重',
    'routing.weightRequired': '权重不能为空',
    'routing.weightInvalid': '权重必须为不小于0的整数',
    'routing.singleLimit': '单笔限额',
    'routing.singleMinimumLimit': '单笔最小限额',
    'routing.dailyLimit': '单日限额',
    'routing.monthlyAllowance': '单月限额',
    'routing.theTemporaryClosureOfInformation': '临时关闭信息',
    'routing.basicInformation': '基础信息',
    'routing.lendingDetail': '放款支付详情', // 需要翻译
    'routing.repaymentDetail': '还款支付详情', // 需要翻译
    'routing.pauseCollection': 'Tangguhkan penagihan',
    'routing.resumeCollection': 'Lanjutkan penagihan',
    'payment.sourceMerchantId': '源租户ID',
    'payment.targetMerchantId': '目标租户ID',
    'base.three.part.config': '三方参数配置',
    'base.three.part.config.type': '支付类型',
    'base.three.part.config.channel': '渠道',
    'base.three.part.config.add': '批量新增',
    'base.three.part.config.delete': '删除',
    'base.three.part.config.modify': '修改',
    'base.three.part.config.id': '参数主键',
    'base.three.part.config.channel.id': '渠道ID',
    'base.three.part.config.channel.name': '渠道名称',
    'base.three.part.config.payment.type': '支付类型',
    'base.three.part.config.payment.desc': '支付类型描述',
    'base.three.part.config.key': '键',
    'base.three.part.config.value': '值',
    'base.three.part.rules.key': '请输入键',
    'nav.bank.bankcard.title': '用户银行卡',
    'nav.bank.title': '银行卡',
    'nav.receipt.title': '单据管理',
    'nav.receipt.lending.title': '放款单据',
    'nav.receipt.lending.detail.title': '放款详情',
    'nav.receipt.repayment.title': '还款单据',
    'nav.receipt.repayment.detail.title': '还款详情',
    'nav.routing.title': '路由配置',
    'nav.routing.lending.title': '放款路由',
    'nav.routing.repayment.title': '还款路由',
    'nav.channel.title': '渠道配置',
    'nav.channel.compare.title': '渠道和银行',
    'nav.channel.threepart.title': '渠道参数',
    'nav.channel.channel.title': '渠道列表',
    'nav.channel.merchant.title': '租户配置',
    'nav.channel.bank.title': '租户和银行'
}
